<template>
    <div class="form">
        <Form ref="info" :model="info" :rules="ruleValidate" :label-width="100">
            <Row :gutter="20">
                <Col span="12">
                    <FormItem label="资讯标题" prop="title">
                        <Input
                            v-model="info.title"
                            :readonly="readonly"
                            :maxlength="256"
                            placeholder
                            :disabled="loading"
                        >
                        </Input>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label="资讯类别" prop="notifyType">
                        <Select
                            v-model="info.notifyType"
                            readonly
                            transfer
                            clearable
                            placeholder
                            :disabled="loading"
                        >
                            <Option
                                v-for="(item, index) in publicNotifyTypeList"
                                :value="item.id"
                                :key="index"
                            >
                                {{ item.text }}
                            </Option>
                        </Select>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="24">
                    <FormItem label="发布楼栋" prop="floorIds">
                        <select-tree
                            v-model="info.floorIds"
                            :list="parkList"
                            multiple
                            fullPathName
                        ></select-tree>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="24">
                    <FormItem label="资讯内容" prop="content">
                        <quill-editor
                            v-model="info.content"
                            :disabled="loading"
                            :height="300"
                            ref="myTextEditor"
                            placeholder="编辑资讯内容"
                        >
                        </quill-editor>
                    </FormItem>
                </Col>
            </Row>
        </Form>
    </div>
</template>
<script>
import { notifyAdd, notifyView, notifyUpdate } from '@/api/notify'
import Dict from '_u/dict'
import mSelectAssetsPark from '@/views/common/m-select-assets-park'
// 富文本
import quillEditor from '_c/quill-editor'

export default {
    name: 'iNoticeForm',

    mixins: [mSelectAssetsPark],

    props: {
        id: {
            type: [String, Number],
            default: '',
        },
    },

    components: { quillEditor },

    inject: {
        $modal: {
            default: null,
        },
    },

    data() {
        return {
            info: {
                id: this.id,
                title: '', // 资讯标题
                notifyType: '1', // 资讯类别
                floorIds: '', // 发布人
                content: '', // 资讯内容
                ver: '', // 版本号
            },
            loading: false,
            dict: {
                publicNotifyType: Dict.NULL,
            },
        }
    },

    computed: {
        canSave() {
            return this.id ? this.$can('update') : this.$can('add')
        },

        readonly() {
            return !this.canSave
        },

        ruleValidate() {
            return {
                title: [{ required: true, message: '资讯标题必填' }],
                notifyType: [{ required: true, message: '资讯类型必填' }],
                floorIds: [{ required: true, message: '发布楼栋必填' }],
                content: [{ required: true, message: '资讯内容必填' }],
            }
        },

        publicNotifyTypeList() {
            return this.dict.publicNotifyType.val()
        },
    },

    methods: {
        fetch() {
            if (this.id) {
                return notifyView(this.id)
            } else {
                return Promise.resolve()
            }
        },
    },

    mounted() {
        var $info = this.$refs.info

        if (!this.canSave) {
            this.$modal.updateBtns([
                { type: 'default', text: '关闭', name: 'cancel' },
            ])
        } else {
            this.$modal.updateBtns([
                { type: 'primary', text: '确定', name: 'confirm' },
                { type: 'default', text: '关闭', name: 'cancel' },
            ])
        }

        // 预加载
        this.$modal.beforeEnter((next) => {
            Promise.all([
                Dict.get(['public_notify_type']),
                this.fetch(),
                this.fetchAssetsPark(),
            ])
                .then((args) => {
                    var [dictGroup, view, parkList] = args

                    Object.keys(this.dict).forEach((name) => {
                        this.dict[name] = dictGroup[name]
                    })

                    if (view) {
                        var viewData = view.data.entity
                        Object.keys(this.info).forEach(
                            (name) => (this.info[name] = viewData[name])
                        )
                    }

                    this.parkList = parkList
                })
                .finally(() => {
                    next()
                })
        })

        // 确定
        this.$modal.onBtnClick('confirm', (next, options) => {
            $info
                .validate()
                .then(() => {
                    var formData = Object.assign({}, this.info)

                    if (this.id) {
                        return notifyUpdate(formData)
                    } else {
                        return notifyAdd(formData)
                    }
                })
                .then((res) => {
                    if (this.id) {
                        this.$Message.success(this.$t('tips.update.success'))
                    } else {
                        this.$Message.success(this.$t('tips.add.success'))
                    }
                })
                .catch((err) => {
                    options.closeModal = false
                })
                .finally(() => {
                    next()
                })
        })
    },
}
</script>
<style lang="less" scoped></style>
